@if (note?.active) {
  <div class="bg-light p-3 my-2 border rounded">
    <h5>{{ header }}</h5>
    <div class="border bg-white rounded-0 px-3 py-2 my-1 mx-0">
      @if (!isClientPortal) {
        <app-note [note]="note" />
      }
      @if (isClientPortal) {
        <div><span class="phi" [innerHtml]="note.safeHtmlContent | safeHtml"></span></div>
      }
    </div>
  </div>
}
